import React from 'react';
import { Salad } from 'lucide-react';
import { openNutritionApp } from '../utils/crossAppSwitch';
import { NAV_ITEMS } from '../config/navItems';
import { useUnreadMessageCount } from '../hooks/useUnreadMessageCount';
import { colors as theme } from '../theme';

const tabs = NAV_ITEMS;

// Logging out is in Settings (13 October 2026): it is rarely wanted, and it sat beside tabs that
// are tapped all day. The desktop top bar keeps its own.
const BottomNav = ({ currentView, onNavigate }) => {
  const unreadMessages = useUnreadMessageCount(currentView);

  return (
  <>
    <style>{`
      .bottom-nav {
        display: none;
      }
      @media (max-width: 768px) {
        .bottom-nav {
          display: flex;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 200;
          background: #141B3D;
          border-top: 1px solid rgba(42, 53, 98, 0.8);
          padding: 8px 0 max(8px, env(safe-area-inset-bottom));
        }
        .bottom-nav-tab {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 3px;
          background: none;
          border: none;
          cursor: pointer;
          padding: 6px 4px;
          min-height: 60px;
          position: relative;
          -webkit-tap-highlight-color: transparent;
        }
        .bottom-nav-tab .bn-icon {
          font-size: 20px;
          line-height: 1;
          transition: color 0.2s ease;
        }
        .bottom-nav-tab .bn-label {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.3px;
          transition: color 0.2s ease;
        }
        /* push page content above the nav bar */
        .bottom-nav-spacer {
          height: 70px;
        }
      }
      @media (min-width: 769px) {
        .bottom-nav-spacer { display: none; }
      }
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    `}</style>

    <nav className="bottom-nav">
      {tabs.map(({ view, label, Icon }) => {
        const isActive = currentView === view;
        return (
          <button
            key={view}
            className="bottom-nav-tab"
            onClick={() => onNavigate(view)}
            style={{ color: isActive ? theme.gold : theme.textMuted }}
          >
            {isActive && (
              <div style={{
                position: 'absolute', top: 0, left: '50%',
                transform: 'translateX(-50%)',
                width: '20px', height: '3px',
                backgroundColor: theme.gold,
                borderRadius: '0 0 3px 3px',
              }} />
            )}
            <span className="bn-icon" style={{ position: 'relative', display: 'inline-flex' }}>
              <Icon size={20} strokeWidth={1.8} />
              {view === 'messages' && unreadMessages > 0 && (
                <span style={{
                  position: 'absolute', top: '-6px', right: '-8px',
                  backgroundColor: theme.danger, color: theme.text,
                  borderRadius: '50%', minWidth: '15px', height: '15px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '9px', fontWeight: 700, padding: '0 3px',
                }}>
                  {unreadMessages > 9 ? '9+' : unreadMessages}
                </span>
              )}
            </span>
            <span className="bn-label">{label}</span>
          </button>
        );
      })}
      <button
        className="bottom-nav-tab"
        onClick={openNutritionApp}
        style={{ color: '#4A8F62' }}
      >
        <span className="bn-icon"><Salad size={20} strokeWidth={1.8} /></span>
        <span className="bn-label">Nutrition</span>
      </button>
    </nav>

    {/* Spacer so page content isn't hidden behind the fixed bar */}
    <div className="bottom-nav-spacer" />
  </>
  );
};

export default BottomNav;
